import { BaseFieldProps } from "./BaseFieldProps";
import React from "react";
import { OIDCUrlField } from "./OIDCUrlField";

export const UserInfoURLField = ({ disabled, onChange, value = "" }: BaseFieldProps) => {
    return (
        <OIDCUrlField
            id="user-info"
            label="User Info URL"
            placeholder="User Info URL"
            description="URL of the UserInfo Endpoint"
            examples={["(i.e. https://idp.example.com/oauth2/userinfo)"]}
            disabled={disabled}
            onChange={onChange}
            value={value}
        />
    );
};

UserInfoURLField.displayName = "UserInfoURLField";
